/* EchoMD
 * Distributed under AGPL3
 *
 * Please include the following in your index.html file
 *
 *   <script src="https://cdn.jsdelivr.net/npm/yamljs@0.3.0/dist/yaml.min.js"></script>
 *   <script src="https://cdn.jsdelivr.net/npm/echarts-gl@1.1.1/dist/echarts-gl.min.js"></script>
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("codemirror"), require("yamljs"), require("../addon/fold"), require("../addon/fold-code")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","codemirror","yamljs","../addon/fold","../addon/fold-code"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.FoldCodeWithEcharts = this.HyperMD.FoldCodeWithEcharts || {}), CodeMirror, YAML, HyperMD.Fold, HyperMD.FoldCode);
})(function (require, exports, CodeMirror, YAML, fold_1, fold_code_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EchartsRenderer = void 0;
    CodeMirror = __importStar(CodeMirror);
    YAML = __importStar(YAML);
    var EchartsRenderer = function (code, info) {
        var id = "_echarts_id_" + Math.round(1e9 * Math.random()).toString(36);
        var el = document.createElement("div");
        el.setAttribute("id", id);
        el.style.width = fold_code_1.convertNumberToString(info.attributes["width"], "400px");
        el.style.height = fold_code_1.convertNumberToString(info.attributes["height"], "400px");
        el.style.maxWidth = info.attributes["maxWidth"] || "100%";
        try {
            var option = {};
            if (code.trim()[0] !== "{") {
                option = YAML.parse(code);
            }
            else {
                option = JSON.parse(code);
            }
            var myChart = window["echarts"].init(el);
            myChart.setOption(option);
            if (info.changed) {
                info.changed();
            }
        }
        catch (error) {
            el.innerText = error.toString();
        }
        return {
            element: el,
            asyncRenderer: null,
        };
    };
    exports.EchartsRenderer = EchartsRenderer;
    if (window["echarts"]) {
        CodeMirror.defineOption("echarts", null, function (cm) {
            fold_code_1.getAddon(cm).clear("echarts");
            fold_1.getAddon(cm).startFold();
        });
        fold_code_1.registerRenderer({
            name: "echarts",
            pattern: /^echarts(\s*$|\s+\{)/i,
            renderer: exports.EchartsRenderer,
            suggested: true,
        });
    }
    else {
        if (window["ECHOMD_DEBUG"]) {
            console.error("[HyperMD] PowerPack fold-code-with-echarts failed to load.\nPlease include\n\n   <script src=\"https://cdn.jsdelivr.net/npm/yamljs@0.3.0/dist/yaml.min.js\"></script>\n   <script src=\"https://cdn.jsdelivr.net/npm/echarts-gl@1.1.1/dist/echarts-gl.min.js\"></script>\n\nin your HTML file");
        }
    }
});
/*

# Example

```echarts
 {
    "title": {
        "text": "ECharts entry example"
    },
    "tooltip": {},
    "legend": {
        "data":["Sales"]
    },
    "xAxis": {
        "data": ["shirt","cardign","chiffon shirt","pants","heels","socks"]
    },
    "yAxis": {},
    "series": [{
        "name": "Sales",
        "type": "bar",
        "data": [5, 20, 36, 10, 10, 20]
    }]
}
```
*/
